var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.to)?_c('router-link',{class:_setup.classes,attrs:{"to":_vm.to}},[_vm._t("default")],2):_c('button',{class:_setup.classes,attrs:{"type":"button"},on:{"click":function($event){return _setup.emit('click', $event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }